export default "__VITE_ASSET__CL354ON5__"